module.exports = __webpack_public_path__ + "img/avatar4.6c382275.png";